import { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Loader } from '@/components/Loader';
import { PreloadQueriesLayout } from '@/layouts/PreloadQueriesLayout';
import { SocketLayout } from '@/layouts/SocketLayout';
import { useUsersStore } from '@/stores/users';
import { LOCAL_STORAGE_KEYS } from '@/utils/constants';
import { getLinkToLogin } from '@/utils/getLinkToLogin';
import { useKioskStore } from '@/stores/kiosk';
import { EUserRoles } from '@/types';
import { KioskAppointmentControlLayout } from '../KioskAppointmentControlLayout';

export const AuthInKioskLayout = () => {
  const { fetchUserData, getRolesDataFromUser, logout } = useUsersStore(
    (state) => ({
      fetchUserData: state.fetchUserData,
      getRolesDataFromUser: state.getRolesDataFromUser,
      logout: state.logout,
    }),
  );
  const kioskInstitutionId = useKioskStore(
    (state) => state.kioskInstitution?.id,
  );
  const [isAuth, setIsAuth] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetching = async () => {
      const token = localStorage.getItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
      if (!token) {
        setLoading(false);
        return;
      }
      try {
        // first accessible kiosk for the institute. There should only be one institution at the kiosk.
        const userData = await fetchUserData(kioskInstitutionId);
        if (!userData || !kioskInstitutionId) {
          return;
        }
        const value = getRolesDataFromUser(userData, kioskInstitutionId);
        // Check whether the user is logged in as a patient; if they are not a patient, they must be logged out
        if (value?.role !== EUserRoles.PATIENT) {
          await logout();
          return;
        }
        setIsAuth(true);
      } catch (error) {
        console.error(error);
        setIsAuth(false);
        navigate(getLinkToLogin());
      } finally {
        setLoading(false);
      }
    };
    void fetching();
  }, [
    kioskInstitutionId,
    fetchUserData,
    getRolesDataFromUser,
    navigate,
    logout,
  ]);

  if (loading) {
    return <Loader />;
  }

  if (!isAuth) {
    return <Outlet />;
  }

  return (
    <SocketLayout>
      <PreloadQueriesLayout>
        <KioskAppointmentControlLayout>
          <Outlet />
        </KioskAppointmentControlLayout>
      </PreloadQueriesLayout>
    </SocketLayout>
  );
};
